import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../data/mock';

const AnimatedNumber = ({ target, suffix, isVisible }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, target]);

  return (
    <span className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 tracking-tight">
      {count}{suffix}
    </span>
  );
};

export const Stats = () => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div
              key={stat.id}
              className={`text-center scroll-fade-in ${isVisible ? 'is-visible' : ''}`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <AnimatedNumber target={stat.value} suffix={stat.suffix} isVisible={isVisible} />
              <p className="mt-3 text-sm sm:text-base font-medium text-slate-500 tracking-wide">
                {stat.label}
              </p>
              <div className="mt-4 mx-auto w-12 h-1 rounded-full bg-gradient-to-r from-teal-400 to-teal-600" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
